import { render, staticRenderFns } from "./Priceinfo.vue?vue&type=template&id=58604687&scoped=true&"
import script from "./Priceinfo.vue?vue&type=script&lang=ts&"
export * from "./Priceinfo.vue?vue&type=script&lang=ts&"
import style0 from "./Priceinfo.vue?vue&type=style&index=0&id=58604687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58604687",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
